<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
    <div class="widget-contents">
      <div class="widget-contents-wrapper">
        <non-trend-chart ref="chartInstance"
                         class="widget-contents-chart"
                         :type="opts.chartType"
                         :x-axis="xAxis"
                         :y-axis="yAxis"
                         :tooltip="toolTip"
                         :data="widgetData"
                         :series-options="seriesOptions"
        />
      </div>
    </div>
  </div>
</template>
<script>
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'

  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'

  // 스토어 헬퍼 객체
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetSecWebFilterHost',
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 1,
        self: this,
        opts: {
          chartType: 'bar'
        },
        title: 'widgetSecWebFilterHost',
        isLock: false,
        isMove: true,
        isResize: true,
        eventBus: true,
        deviceType: [20, 21],
        restData: {
          result: [],
          unit_time: ''
        },
        seriesOptions: {
          barWidth: '40%'
        },
        widgetData: []
      }
    },
    computed: {
      xAxis () {
        const xAxisOptions = {}

        if (this.opts.chartType === 'bar') {
          xAxisOptions.axisLabel = {
            formatter: (value) => {
              return `${this.kmgtConverter(value)}`
            }
          }
        }

        return xAxisOptions
      },
      yAxis () {
        const yAxisOptions = {}

        if (this.opts.chartType === 'column') {
          yAxisOptions.axisLabel = {
            formatter: (value) => {
              return `${this.kmgtConverter(value)}`
            }
          }
        }

        return yAxisOptions
      },
      toolTip () {
        return {
          formatter: (params) => {
            const {name, value, marker} = _.isArray(params) ? params[0] : params
            return `${marker} ${name} : <b>${this.separateByComma(value)}${this.restData.unit_time}</b>`
          }
        }
      },
      widgetChartMenu () {
        return [
          {
            icon: 'icon-chart-pie',
            label: 'Pie Chart',
            value: 'pie'
          },
          {
            icon: 'icon-chart-bar',
            label: 'Bar Chart',
            value: 'bar'
          },
          {
            icon: 'icon-chart-column',
            label: 'Column Chart',
            value: 'column'
          },
          {
            icon: 'icon-chart-tree-map',
            label: 'Tree Map',
            value: 'treemap'
          }
        ]
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // 셀프 객체 초기화
      this.self = null
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      // 위젯 대상 장비 필터 설정.
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      async getWidgetContentsData (init = false, extraParams = null) {
        // Progress 출력 여부
        this.showProgress(true)

        // initFlag가 True면 기존 차트 데이터 초기
        if (init) {
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        const contentsOptions = {
          widgetType: 'web_filter_host_top'
        }

        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams && extraParams.machId) {
          contentsOptions.machId = extraParams.machId
        }

        // API 호출
        const {code, result} = await this.getWidgetData(contentsOptions)

        // Series 데이터 구성
        if (code === 'ok') {
          this.restData = result

          const attackerIpTopn = []

          for (const attackerIp of this.restData.result || []) {
            attackerIpTopn.push({
              name: attackerIp.name,
              value: attackerIp.value
            })
          }

          this.widgetData = attackerIpTopn
        }

        // Progress 출력 여부
        this.showProgress(false)
      }
    },
    watch: {}
  }
</script>

<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .widget-contents {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-wrapper {
    flex-grow: 1;
    display: flex;
  }

  .widget-contents-chart {
    flex-grow: 1;
  }
</style>
